import { bootstrapApplication } from '@angular/platform-browser';
import { APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import {
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
  PreloadAllModules,
} from '@angular/router';
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { TenantConfigService } from './app/services/tenant-config.service';
import { environment } from './environments/environment';
import { provideHttpClient } from '@angular/common/http';

function getTenant(): string {
  return environment.tenant || 'reisser';
}

function initializeTenantConfig(tenantConfigService: TenantConfigService) {
  const tenant = getTenant();
  return () => tenantConfigService.loadConfig(tenant);
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(HttpClientModule),
    TenantConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTenantConfig,
      deps: [TenantConfigService],
      multi: true,
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(),
  ],
});
